// @ts-check
console.log("Component search loaded");
document.addEventListener("DOMContentLoaded", function () {
	syncCheckboxesWithUrl(); // Sync checkboxes on initial page load
	setupEventListeners();
	setupPaginationListeners();
	setupMobileFilterScrolling();
});

function setupEventListeners() {
	/** @type {NodeListOf<HTMLInputElement>} */
	const filters = document.querySelectorAll(
		'[data-filter-count] input[type="checkbox"], [data-filter-count] input[type="number"]'
	);

	filters.forEach((filter) => {
		filter.removeEventListener("change", handleFilterChange);
		filter.addEventListener("change", handleFilterChange);
	});

	/** @type {HTMLSelectElement | null} */
	const sortBy = /** @type {HTMLSelectElement | null} */ (
		document.getElementById("sort-by")
	);
	if (sortBy) {
		sortBy.addEventListener("change", handleSortChange);
	}
}

/**
 * @param {Event} event
 */
function handleFilterChange(event) {
	// Important: Get the target input element
	const target = /** @type {HTMLInputElement} */ (event.target);

	// Get current URL parameters
	const url = new URL(window.location.href);
	const params = new URLSearchParams(url.search);

	// Reset pagination to page 1 when filters change
	params.delete('page');

	// Handle checkbox changes - important for unchecking
	if (target.type === "checkbox") {
		// Get existing values for this filter
		const existingValue = params.get(target.name);
		const existingValues = existingValue ? existingValue.split(",") : [];

		if (target.checked) {
			// If checked, add value if not already present
			if (!existingValues.includes(target.value)) {
				existingValues.push(target.value);
			}
		} else {
			// If unchecked, remove value if present
			const index = existingValues.indexOf(target.value);
			if (index !== -1) {
				existingValues.splice(index, 1);
			}
		}

		// Update or remove parameter
		if (existingValues.length > 0) {
			params.set(target.name, existingValues.join(","));
		} else {
			params.delete(target.name);
		}

		// Update URL and load page
		const newUrl =
			url.pathname +
			(params.toString() ? "?" + params.toString().replace(/%2C/g, ",") : "");
		loadPage(newUrl);
	} else {
		// For non-checkbox inputs, use the original approach
		const newUrl = getUpdatedFilterUrl();
		loadPage(newUrl);
	}
}

function handleSortChange() {
	const newUrl = getUpdatedFilterUrl();
	loadPage(newUrl);
}

/**
 * @returns {string}
 */
function getUpdatedFilterUrl() {
	const url = new URL(window.location.href);
	const params = new URLSearchParams(url.search);

	// Reset pagination to page 1 when filters change
	params.delete('page');

	/** @type {HTMLSelectElement | null} */
	const sortBy = /** @type {HTMLSelectElement | null} */ (
		document.getElementById("sort-by")
	);
	if (sortBy && sortBy.value) {
		params.set("sort_by", sortBy.value);
	} else {
		params.delete("sort_by");
	}

	/** @type {NodeListOf<HTMLInputElement>} */
	const collectionFilters = document.querySelectorAll(
		"collection-filters input"
	);

	// Clear existing entries for collection filters to avoid duplications
	collectionFilters.forEach((input) => {
		if (input.type === "checkbox" || input.type === "number") {
			params.delete(input.name);
		}
	});

	// Re-iterate to set or append values based on user selections
	collectionFilters.forEach((input) => {
		if (input.checked || (input.type === "number" && input.value)) {
			const existing = params.get(input.name);
			if (existing) {
				params.set(input.name, existing + "," + input.value);
			} else {
				params.set(input.name, input.value);
			}
		}
	});

	const finalQueryString = params.toString().replace(/%2C/g, ",");
	return url.pathname + (finalQueryString ? "?" + finalQueryString : "");
}

/**
 * Synchronizes checkbox states with URL parameters
 */
function syncCheckboxesWithUrl() {
	const params = new URLSearchParams(window.location.search);

	/** @type {NodeListOf<HTMLInputElement>} */
	const collectionFilters = document.querySelectorAll(
		"collection-filters input"
	);

	collectionFilters.forEach((input) => {
		if (input.type === "checkbox") {
			// Get all values for this filter name
			const paramValues = params.get(input.name);
			if (paramValues) {
				// Split comma-separated values and check if this input's value is included
				const values = paramValues.split(",");
				input.checked = values.includes(input.value);
			} else {
				input.checked = false;
			}
		} else if (input.type === "number") {
			// For number inputs, just set the value
			input.value = params.get(input.name) || "";
		}
	});
}

/**
 * Updates filter sections with fresh content from server
 * @param {Document} doc - The parsed HTML document
 */
function updateFilterSections(doc) {
	// Store which filter details are currently open
	/** @type {Set<string>} */
	const openFilters = new Set();
	
	// Find currently open filter details
	document.querySelectorAll('collection-filters details[open]').forEach((details) => {
		// Use filter label as identifier
		const summary = details.querySelector('summary');
		if (summary) {
			const label = summary.textContent?.trim();
			if (label) {
				openFilters.add(label);
			}
		}
	});

	// Find all collection-filters elements (both desktop and mobile)
	/** @type {NodeListOf<Element>} */
	const currentFilters = document.querySelectorAll('collection-filters');
	/** @type {NodeListOf<Element>} */
	const newFilters = doc.querySelectorAll('collection-filters');
	
	// Update each filter section
	currentFilters.forEach((currentFilter, index) => {
		const newFilter = newFilters[index];
		if (newFilter) {
			currentFilter.innerHTML = newFilter.innerHTML;
		}
	});

	// Restore open state for filters that were previously open or have active values
	document.querySelectorAll('collection-filters details').forEach((details) => {
		const summary = details.querySelector('summary');
		if (summary) {
			const label = summary.textContent?.trim();
			
			// Check if this filter has active values (indicated by count in parentheses)
			const hasActiveValues = label && label.includes('(') && label.includes(')');
			
			// Open if it was previously open OR if it has active values
			if ((label && openFilters.has(label)) || hasActiveValues) {
				details.setAttribute('open', '');
			}
		}
	});
}

/**
 * @param {string} url
 * @param {boolean} [updateHistory=true]
 */
function loadPage(url, updateHistory = true) {
	const separator = url.includes("?") ? "&" : "?";

	// This must match the name of the main section for search
	fetch(url + separator + "section_id=main-search-enhanced")
		.then((response) => response.text())
		.then((html) => {
			const parser = new DOMParser();
			const doc = parser.parseFromString(html, "text/html");
			const newSection = doc.getElementById("product-grid");
			const replaceSection = document.getElementById("product-grid");

			if (!replaceSection || !newSection) {
				return;
			}

			replaceSection.innerHTML = newSection.innerHTML;

			// Update filter sections as well to refresh counts
			updateFilterSections(doc);

			if (updateHistory) {
				window.history.pushState({ prevUrl: url }, "", url);
			}

			// Sync checkboxes with the new URL after loading page
			syncCheckboxesWithUrl();

			const scrollPosition = document.getElementById("breadcrumbs");
			if (scrollPosition) {
				scrollPosition.scrollIntoView({ behavior: "smooth" });
			}

			setupEventListeners();
			setupMobileFilterScrolling();

			const renderCompleteEvent = new CustomEvent("sectionRender:search", {
				detail: {
					sectionId: "product-grid",
					url: url,
				},
			});
			document.dispatchEvent(renderCompleteEvent);
		})
		.catch((error) => console.error("Error loading the page:", error));
}

function setupPaginationListeners() {
	/** @type {NodeListOf<HTMLAnchorElement>} */
	const paginationLinks = document.querySelectorAll(".pagination a");

	paginationLinks.forEach((link) => {
		link.addEventListener("click", function (/** @type {MouseEvent} */ event) {
			event.preventDefault();
			const target = /** @type {HTMLAnchorElement} */ (event.currentTarget);
			const url = target.href;
			loadPage(url);
		});
	});
}

window.addEventListener(
	"popstate",
	function (/** @type {PopStateEvent} */ event) {
		if (event.state && event.state.prevUrl) {
			loadPage(event.state.prevUrl, false);
		}
	}
);

/**
 * Setup mobile filter scrolling behavior
 */
function setupMobileFilterScrolling() {
	/** @type {HTMLButtonElement | null} */
	const filterToggle = document.querySelector('[data-filter-toggle]');
	/** @type {HTMLDivElement | null} */
	const filterPanel = document.querySelector('[data-all-collection-filters]');
	
	if (!filterToggle || !filterPanel) return;
	
	// Function to handle body scroll prevention
	function preventBodyScroll() {
		if (window.innerWidth < 1024) { // Only on mobile
			document.body.classList.add('filter-panel-open');
		}
	}
	
	function allowBodyScroll() {
		document.body.classList.remove('filter-panel-open');
	}
	
	// Handle focus events on filter toggle button
	filterToggle.addEventListener('focus', preventBodyScroll);
	filterToggle.addEventListener('blur', (e) => {
		// Only allow body scroll if focus is not moving to the filter panel
		const relatedTarget = /** @type {Node | null} */ (e.relatedTarget);
		if (!filterPanel.contains(relatedTarget)) {
			allowBodyScroll();
		}
	});
	
	// Handle focus events on filter panel
	filterPanel.addEventListener('focusin', preventBodyScroll);
	filterPanel.addEventListener('focusout', (e) => {
		// Only allow body scroll if focus is not moving to the filter toggle or staying within panel
		const relatedTarget = /** @type {Node | null} */ (e.relatedTarget);
		if (!filterToggle.contains(relatedTarget) && !filterPanel.contains(relatedTarget)) {
			allowBodyScroll();
		}
	});
	
	// Handle clicks outside the filter panel to close it
	document.addEventListener('click', (e) => {
		const target = /** @type {Node | null} */ (e.target);
		if (!filterToggle.contains(target) && !filterPanel.contains(target)) {
			allowBodyScroll();
		}
	});
	
	// Handle escape key to close filter panel
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') {
			allowBodyScroll();
			filterToggle.blur();
		}
	});
}